import {Action} from "redux"
import {compose, Dispatcher, DispatcherActionLike} from "../../../lib/utils";
import {ProcessFormAction, ProcessFormActionWrapper} from "./action";
import {connect, Store} from "react-redux";
import {CallbackProps, ProcessForm, ValueProps} from "./presentation";
import {CommandCaller} from "../../../lib/commands";
import {saveReturnCallback} from "../../../lib/sbhtml/form";

export type PaymentType = 'all'|'scheduled payments'|'reusable payer'
export type CollationType = 'none'|'member'|'organisation'
export type ProcessDirection = 'before'|'after'

export type PricingOption = {
	id: string
	label: string
}

export type Status = {
	id: string
	label: string
	color: string
}

export type State = {
	processId: number
	name: string
	pricingOptions: PricingOption[]
	multiPricingOption: boolean
	selectedPricingOptions: string[]
	multiStatus: boolean
	statuses: Status[]
	selectedStatuses: string[]
	selectedPaymentType: PaymentType
	processDays: string
	processDirection: ProcessDirection
	collationType: CollationType
	sendEmails: boolean
	enabled: boolean
	submitting: boolean
}

export type ProcessFormStore = Store<State>

export type OwnProps = {
	refreshSampleGrid: () => void
	store: ProcessFormStore
	returnUrl: string
	ajaxUrl: string
	disabledPricingOptions: string[]
	paymentTypes: PaymentType[]
}


const mapStateToProps = (state: State, ownProps: OwnProps): ValueProps => ({
	...state,
	disabledPricingOptions: ownProps.disabledPricingOptions,
	paymentTypes: ownProps.paymentTypes,
	collationEnabled: state.selectedPaymentType == 'all',
	hasPaymentField: ownProps.paymentTypes.length > 1
})

const mapDispatchToProps = (dispatch: Dispatcher<Action, State>, ownProps: OwnProps): CallbackProps => {
	const wrap = (action: ProcessFormAction): ProcessFormActionWrapper => ({
		type: "process form action",
		action
	})
	const dispatchAction: DispatcherActionLike<ProcessFormAction, Action> = compose<ProcessFormAction, Action, Action>(wrap, dispatch)
	const saveProcess = makeSaveProcessAction(dispatchAction, ownProps);

	const dispatchAndRefresh = <A>(f: (a: A) => void) => (a: A) => dispatch(() => {f(a); ownProps.refreshSampleGrid()})

	return {
		onCancel: () => { window.location.assign(ownProps.returnUrl) },
		setName: dispatchAndRefresh(name => dispatchAction({type: "set name", name})),
		setMultiPricingOption: dispatchAndRefresh(multiPricingOption => dispatchAction({type: "set multi pricing option", multiPricingOption})),
		setPricingOptions: dispatchAndRefresh((pricingOptions) => dispatchAction({type: "set pricing options", pricingOptions})),
		setMultiStatus: dispatchAndRefresh((multiStatus) => dispatchAction({type: "set multi status", multiStatus})),
		setStatuses: dispatchAndRefresh((statuses) => dispatchAction({type: "set statuses", statuses})),
		setPaymentType: dispatchAndRefresh((paymentType) => dispatchAction({type: "set payment type", paymentType})),
		setProcessDays: dispatchAndRefresh((processDays) => dispatchAction({type: "set process days", processDays})),
		setProcessDirection: dispatchAndRefresh((processDirection) => dispatchAction({type: "set process direction", processDirection})),
		setCollationType: dispatchAndRefresh((collationType) => dispatchAction({type: "set collation type", collationType})),
		setSendEmails: (sendEmails) => dispatchAction({type: "set send emails", sendEmails}),
		setEnabled: (enabled) => dispatchAction({type: "set enabled", enabled}),
		saveProcess: () => dispatch(saveProcess),
		saveProcessThenReturn: () => dispatch(saveReturnCallback<State>(
			dispatch,
			saveProcess,
			ownProps.returnUrl
		))
	}
}

const makeSaveProcessAction = (dispatchWrapped: DispatcherActionLike<ProcessFormAction, Action>, ownProps: OwnProps) => async (dispatchUnwrapped: DispatcherActionLike<Action, void>, getState: () => State) => {
	dispatchWrapped({type: "set submitting", submitting: true})

	const state = getState();
	try {
		const processId = state.processId
		const process = processId > 0 ? {processId: processId} : {}
		const saveParams =
			{
				...process,
				name: state.name,
				pricingOptions: state.selectedPricingOptions,
				statuses: state.selectedStatuses,
				paymentType: state.selectedPaymentType,
				days: state.processDays,
				beforeAfter: state.processDirection,
				collation: state.collationType,
				sendEmails: state.sendEmails,
				enabled: state.enabled
			}

		const id = await new CommandCaller(ownProps.ajaxUrl).runPost('save process', saveParams) as number
		dispatchWrapped({type: "set process id", id: id})
	} catch (e) {
		window.alert("There was an unexpected error. Ensure you're logged in, your internet connection is working, and try reloading the page")
	}

	dispatchWrapped({type: "set submitting", submitting: false})
}

export const ProcessFormApp = connect<ValueProps, CallbackProps, OwnProps, State>(
	mapStateToProps,
	mapDispatchToProps
)(ProcessForm)



// WEBPACK FOOTER //
// ./src/membership3/auto-renewal/process-form/app.ts